<template>
  <div class="search-local__search-wrapper">
    <div class="search-local__search-field">
      <icon
        class="search-local__search-icon"
        fill="rgb(113, 117, 121)"
        type="search">
      </icon>
      <input
        v-model="query"
        :class="{
          'search-local__search-icon--results': hasHits
        }"
        :placeholder="placeholder"
        class="search-local__search-input"
        @keyup="onSearch" />
    </div>
    <ul class="search-local__search-results" v-if="hasHits">
      <li
        v-for="hit in hits"
        v-html="hit.highlightedName"
        :key="hit.path"
        class="search-local__search-result"
        @click="onClickResult(hit)">
      </li>
    </ul>
  </div>
</template>

<script>
import Icon from '@/components/Icon'
import { ADD_TO_QUERY } from '@/store/actionTypes'

export default {
  name: 'SearchLocalSearch',
  components: {
    Icon
  },

  data() {
    return {
      hits: [],
      query: ''
    }
  },

  props: {
    list: Array,
    placeholder: String,
    queryType: {
      required: true,
      type: String
    }
  },

  computed: {
    hasHits() {
      return this.hits.length > 0
    }
  },

  methods: {
    onSearch() {
      const searchString = this.query.toLowerCase()

      if (searchString.length < 2) {
        this.hits = []
        return
      }

      this.hits = this.list
        .filter(({ name }) => name.toLowerCase().includes(searchString))
        .map(hit => {
          const queryRegEx = new RegExp(`(${searchString})`, 'ig')

          return {
            ...hit,
            highlightedName: hit.name.replace(queryRegEx, '<strong>$1</strong>')
          }
        })
    },

    onClickResult({ name, path }) {
      this.hits = []
      this.query = ''

      const payload = {
        name,
        path
      }

      if (this.queryType === 'languages') {
        this.$store.commit(ADD_TO_QUERY, {
          payload,
          type: this.queryType
        })
      } else {
        window.eventBus.$emit('openExpansionPanel', {
          ...payload,
          type: this.queryType
        })
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.search-local__search-wrapper {
  position: relative;
}
.search-local__search-icon {
  position: absolute;
  top: 10px;
  left: 15px;
}

.search-local__search-input {
  border: 1px solid var(--color-iron);
  border-radius: 4px;
  box-sizing: border-box;
  color: #000;
  font-size: 16px;
  padding: var(--spacing-third) var(--spacing-medium) var(--spacing-third) 40px;
  width: 100%;

  @media (--bp-desktop) {
    margin-top: var(--spacing-half);
  }
}

.search-local__search-icon--results {
  border-radius: 4px 4px 0 0;
}

.search-local__search-results {
  background-color: var(--color-white);
  border: 1px solid var(--color-geyser);
  border-top: 0;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 100%;
  left: 0px;
  width: 100%;
  z-index: 2;
}

.search-local__search-result {
  cursor: pointer;
  padding: var(--spacing-half);

  &:not(:last-child) {
    border-bottom: 1px solid var(--color-geyser);
  }

  &:first-letter {
    text-transform: capitalize;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }

  &:hover {
    background-color: var(--color-alabaster);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchLocalSearch.vue